import axios from "axios";
import { API_BASE_URL } from "../../../constants/apiConstants";

export function validarCodigo(email, codigo) {
  const data = {
    email: email,
    codigo: codigo,
  };

  return axios
    .post(`${API_BASE_URL}Medicos/validarCodigo`, data, {
      headers: {
        Accept: "text/plain",
        "Content-Type": "application/json",
      },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw error;
    });
}

export async function resendCodigo(email) {
  const url = `${API_BASE_URL}Medicos/reenviarCodigo`;

  const data = {
    email: email
  };

  try {
    const response = await axios.post(url, data, {
      headers: {
        Accept: "text/plain",
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    throw error;
  }
}